/*
 * @Author: xym
 * @Date: 2020-06-18 11:25:02
 * @Last Modified by:   xym
 * @Last Modified time: 2020-06-18 11:25:02
 */

/**
 * 将该日期对象转化为指定格式的字符串。
 * 月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
 * 年(y)可以用 1-4个占位符，毫秒(f)只能用 1个占位符(是 1-3位的数字)。
 * @param {String} format 例：'yyyy-MM-dd hh:mm:ss.fff'。
 * @returns {String}
 */
Date.prototype.toFormattedString = function (format) { // eslint-disable-line
  var O = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'H+': this.getHours(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'f': this.getMilliseconds()
  }
  if (/(y+)/.test(format)) {
    format = format.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in O) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? O[k] : ('00' + O[k]).substr(('' + O[k]).length))
    }
  }
  return format
}
/**
 * 判断该日期对象指示的日期是否是今天。
 * @returns {Boolean}
 */
Date.prototype.isToday = function () { // eslint-disable-line
  var now = new Date()
  return this.getFullYear() === now.getFullYear() && this.getMonth() === now.getMonth() && this.getDate() === now.getDate()
}
/**
 * ``返回该日期对象月份部分的缩写字符串，该字符串格式因不同语言而不同。``
 * @param {String} locale 指定使用哪种语言格式化规则，遵循 BCP-47 规则。
 * @returns {String}
 */
Date.prototype.toLocaleShortMonthString = function (locale) { // eslint-disable-line
  var month = this.getMonth()
  var lang = String(locale || '').toLowerCase()
  if (lang.startsWith('zh')) {
    return ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'][month] /* Chinese */
  } else if (lang.startsWith('ja')) {
    return ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'][month] /* Japanese */
  } else if (lang.startsWith('ko')) {
    return ['일', '이', '삼', '사', '오', '유', '칠', '팔', '구', '시', '십일', '십이'][month] /* Korean */
  } else if (lang.startsWith('nl')) {
    return ['Jan', 'Feb', 'Maa', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'][month] /* Dutch */
  } else if (lang.startsWith('de')) {
    return ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'][month] /* German */
  } else if (lang.startsWith('it')) {
    return ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'][month] /* Italian */
  } else if (lang.startsWith('pt')) {
    return ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'][month] /* Portuguese */
  } else if (lang.startsWith('sv')) {
    return ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'][month] /* Swedish */
  } else if (lang.startsWith('fr')) {
    return ['Jan', 'Fev', 'Mars', 'Avr', 'Mai', 'Juin', 'Juillet', 'Aou', 'Sept', 'Oct', 'Nov', 'Dec'][month] /* French */
  } else {
    return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'][month] /* English */
  }
}

/**
 * 获取日期格式（兼容IOS日期格式）
 */
Date.getUTCDate = function(date, { format } = {}) {
  if (!(date instanceof Date)) {
    date = strToDate(date)
  }
  if (date) {
    const minutes = date.getMinutes()
    const offset = date.getTimezoneOffset()
    date.setMinutes(minutes - offset)
  }
  if (format) {
    return date.toFormattedString(format)
  }
  return date
}
/**
 * 字符串转换为时间
 * @param  {String} src 字符串
 */
export function strToDate(dateObj) {
  dateObj = dateObj.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '').replace(/(-)/g, '/')
  if (dateObj.indexOf('.') > 0)dateObj = dateObj.slice(0, dateObj.indexOf('.'))

  return new Date(dateObj)
}

// 获取日期的时区格式
export function toDateGMT(date, options = {}) {
  // moment 的日期
  let timeStr = options.time
  if (timeStr === 0) timeStr = '00:00:00'
  if (timeStr === 24) timeStr = '23:59:59'
  // 当前时区与中时区时差，以min为维度
  // const y = date.year()
  // const m = date.month() + 1
  const d = ('0' + date.date()).slice(-2)
  // const zone = date.zone() // -480
  // const absH = parseInt(Math.abs(zone) / 60)
  // const absM = parseInt(Math.abs(zone) % 60)
  // const dif =
  //   (zone < 0 ? `+` : '-') +
  //   (absH < 10 ? '0' + absH : absH) +
  //   (absM < 10 ? '0' + absM : absM)
  // return date.format(`${y}-${m}-${d}T${timeStr}.000${dif}`)
  return date.format(`yyyy-MM-${d}T08:00:00.000+0800`)
}
